#import "@/components/common/StoryPreviewFragment.gql"
#import "@/components/common/LinkFragment.gql"

fragment FixedBoxTopicFeatureFragment on fixedBoxTopicFeature_Entry {
  typeHandle
  boxTitle
  boxCta {
    ...LinkFragment
  }
  stories {
    uri
    ...StoryPreviewFragment
  }
}
